import * as React from "react";
import styled from "styled-components";

interface AdSystemInfoProps {
  systemId: string;
  systemName: string;
  streamId: string;
}

export const AdSystemInfo: React.FC<AdSystemInfoProps> = ({
  systemId,
  systemName,
  streamId,
}) => {
  return (
    <SystemContainer>
      <StyledInfoContent>
        <LabelRow>
          <Label>StremId:</Label>
          <Value>{streamId ? streamId !== "" ? streamId : "n/a" : "n/a"}</Value>
        </LabelRow>
      </StyledInfoContent>
    </SystemContainer>
  );
};

const SystemContainer = styled.div`
  border-radius: 0 0 3px 3px;
  background-color: rgba(200, 200, 200, 1);
  display: flex;
  /*gap: 0px 77px;*/
  color: rgba(91, 91, 91, 1);
  flex-wrap: wrap;
  padding: 4px 18px;
  font-weight: 400;
  font-size: 16px;
  font-family: "Roboto","Montserrat";
  @media (max-width: 991px) {
    max-width: 100%;
    padding: 0 20px;
  }
  height: 100%;
`;

const StyledInfoContent = styled.div`
  display: flex;
  grid-template-columns: min-content;
  /*gap: 8px 16px;*/
  width: 100%;
  max-width: 600px;
  /*background: #D9D9D9;*/
  padding: 0px;
  /*border-radius: 8px;*/
  font-family: "Roboto","Montserrat";
`;

const LabelRow = styled.div`
  display: contents;
`;

const Label = styled.div`
  font-weight: bold;
  color: #5B5B5B;
  width: 125px;
  padding: 8px 0px;
`;

const Value = styled.div`
  color: #5B5B5B;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: "auto";
  overflow: hidden;
  padding: 8px 0px;
`;

const Hr = styled.div`
  grid-column: span 2;
  border-bottom: 1px solid  #B1B1B1;
  margin: 1px 0;
`;
